import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CareLinksState } from './models/care-links-state.models';

export const selectCareLinksState = createFeatureSelector<CareLinksState>('careLinks');

export const selectCaregivers = createSelector(
  selectCareLinksState,
  (state: CareLinksState) => state.caregivers
);

export const selectActiveCaregivers = createSelector(
  selectCaregivers,
  (caregivers) => caregivers.filter(c => c.status === 'active')
);

export const selectPendingCaregivers = createSelector(
  selectCaregivers,
  (caregivers) => caregivers.filter(c => c.status === 'pending')
);

export const selectCareLinksLoading = createSelector(
  selectCareLinksState,
  (state: CareLinksState) => state.loading
);

export const selectCareLinksInviting = createSelector(
  selectCareLinksState,
  (state: CareLinksState) => state.inviting
);

export const selectCareLinksError = createSelector(
  selectCareLinksState,
  (state: CareLinksState) => state.error
);
